module.exports = "    <!-- activeprogram -->\r\n    <div class=\"wrapperActiveProgram\">\r\n        <div class=\"activeProgramTitleWrapper\">ACTIVE PROGRAM</div>\r\n        <div class=\"activeProgramWrapper\">\r\n            <div *ngFor=\"let item of programJson1[0]\">{{item}}</div>\r\n        </div>\r\n    </div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/allPanels/active-program/active-program.component.html
// module id = ./src/app/allPanels/active-program/active-program.component.html
// module chunks = main